export default {
  articletype: 'Article type',
  articletypes: 'Articles types',
  verbose_articletype: 'an article type',
  select_articletype: 'Select an article type',
  messages: {
    articletype_not_found: 'Article type not found',
  },
};
